import React, { useState } from "react";
import { motion } from "framer-motion";

const IconCard = ({
  icon,
  title,
  description,
  quote = null, // ✅ New optional prop
  borderGradient = "from-green-400 to-blue-500",
  hoverScale = 1.05,
  className = "",
  txtcolor = "text-gray-800",
  arrowIcon = null,
  iconPosition = "top-center",
  cardBg = "bg-white",
  iconBg = "bg-green-100",
}) => {
  const [isHovered, setIsHovered] = useState(false);

  // 🔹 Icon position map
  const iconClassMap = {
    "top-right": "-top-6 -right-6",
    "top-left": "-top-6 -left-6",
    "top-center": "-top-8 left-[43%] -translate-x-1/2",
  };

  return (
    <motion.div
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      whileHover={{ scale: hoverScale }}
      transition={{ duration: 0.3 }}
      className={`relative rounded-2xl mb-5 shadow-md hover:shadow-xl transition-all duration-300 h-full ${className}`}
    >
      {/* ✅ Gradient Border Wrapper */}
      <div className={`p-[2px] rounded-2xl bg-gradient-to-b ${borderGradient} h-full`}>
        {/* ✅ Inner Card */}
        <div
          className={`rounded-2xl p-6 pt-12 flex flex-col items-center justify-start text-center ${cardBg} h-full`}
        >
          {/* Icon */}
          {icon && (
            <motion.div
              className={`absolute w-16 h-16 p-3 border-[6px] border-white rounded-full flex items-center justify-center ${iconBg} ${iconClassMap[iconPosition]}`}
              animate={{
                y: isHovered ? -8 : 0,
              }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
            >
              {icon}
            </motion.div>
          )}

          {/* Title */}
          <h3 className={`text-xl font-semibold mb-2 ${txtcolor}`}>{title}</h3>

          {/* Quote (optional) */}
          {quote && (
            <p className={`italic text-orange-600 font-semibold text-md mb-3 ${txtcolor} opacity-80`}>
              “{quote}”
            </p>
          )}

          {/* Description */}
          <p className={`${txtcolor} text-md flex-grow leading-relaxed`}>
            {description}
          </p>

          {/* Arrow / CTA Icon */}
          {arrowIcon && <div className="mt-4">{arrowIcon}</div>}
        </div>
      </div>
    </motion.div>
  );
};

export default IconCard;
